import { GetColab } from '../../modules/Colab/types';

export type FilterOption = {
  id: string;
  label: string;
  value: string;
};

export const recordStatuses: FilterOption[] = [
  { id: 'New', label: 'New', value: 'New' },
  { id: 'Active', label: 'Active', value: 'Active' },
  { id: 'Closed', label: 'Closed', value: 'Closed' },
];

const categoryNames = [
  'ADAS',
  'Camera and Xcall',
  'Car Sharing',
  'Climate',
  'Connectivity & Communication',
  'Driving dynamic & experience',
  'Energy Management',
  'Hardware',
  'HMI design updates',
  'Legal & Compliance',
  'Lights',
  'Lynk &co apps',
  'Media',
  'Mobile App',
  'Navigation',
  'New functions',
  'Other',
  'Parking',
  'Positive feedback',
  'Profile',
  'Quick access',
  'Seats',
  'Settings',
  'Smartphone projection',
  'Sounds',
  'Sunroof/Sunblind',
  'System defects',
  'Text improvement',
  'Third party apps',
  'Voice Assistant',
];

const categoryKeywords: Record<string, string[]> = {
  ADAS: ['adas', 'adaptive cruise', 'lane', 'pilot assist', 'driver assist', 'aeb', 'acc'],
  'Camera and Xcall': ['camera', 'xcall', 'e-call', 'ecall', 'sos'],
  'Car Sharing': ['sharing', 'booking', 'book', 'reservation', 'reserve', 'cancel', 'trip'],
  Climate: ['climate', 'ac', 'a/c', 'air condition', 'heating', 'temperature', 'defrost'],
  'Connectivity & Communication': [
    'connect',
    'bluetooth',
    'wifi',
    'network',
    'pairing',
    'internet',
    'online',
    'offline',
  ],
  'Driving dynamic & experience': ['drive', 'driving', 'steering', 'brake', 'braking', 'suspension', 'acceleration'],
  'Energy Management': ['charge', 'charging', 'charger', 'battery', 'soc', 'range', 'energy'],
  Hardware: ['hardware', 'button', 'knob', 'sensor', 'module'],
  'HMI design updates': ['hmi', 'layout', 'design', 'ui', 'ux', 'screen', 'display', 'ihu', 'dhu', 'touch'],
  'Legal & Compliance': ['legal', 'privacy', 'gdpr', 'compliance', 'terms', 'consent'],
  Lights: ['light', 'lights', 'headlight', 'indicator', 'blinkers', 'ambient'],
  'Lynk &co apps': ['lynk', 'lynkco', 'lynk & co app', 'lynk app'],
  Media: ['media', 'radio', 'spotify', 'music', 'audio', 'speaker', 'volume'],
  'Mobile App': ['mobile app', 'app', 'application', 'login', 'log in', 'crash', 'bug', 'version'],
  Navigation: ['navigation', 'map', 'maps', 'gps', 'route'],
  'New functions': ['feature', 'function', 'new function', 'request', 'wish'],
  Parking: ['parking', 'park', 'pdc', 'sensor'],
  'Positive feedback': ['good', 'great', 'love', 'nice', 'happy', 'positive', 'thanks'],
  Profile: ['profile', 'account', 'user', 'email', 'password'],
  'Quick access': ['quick access', 'shortcut', 'favorite', 'favourite'],
  Seats: ['seat', 'seats', 'heating seat', 'seat heater'],
  Settings: ['setting', 'settings', 'preference', 'configuration'],
  'Smartphone projection': ['carplay', 'android auto', 'smartphone projection', 'phone projection'],
  Sounds: ['sound', 'sounds', 'alert', 'chime', 'notification sound'],
  'Sunroof/Sunblind': ['sunroof', 'sunblind', 'roof blind'],
  'System defects': ['defect', 'error', 'failed', 'failure', 'issue', 'problem', 'crash'],
  'Text improvement': ['text', 'translation', 'wording', 'spelling', 'copy'],
  'Third party apps': ['third party', '3rd party', 'youtube', 'google', 'spotify'],
  'Voice Assistant': ['voice', 'assistant', 'speech', 'command'],
};

export const recordCategories: FilterOption[] = categoryNames.map(category => ({
  id: category
    .replace(/[^a-z0-9]+/gi, '-')
    .replace(/^-|-$/g, '')
    .toLowerCase(),
  label: category,
  value: category,
}));

export function getUniqueOptions(values: Array<string | undefined | null>): FilterOption[] {
  return Array.from(
    new Set(
      values
        .map(value => (value || '').trim())
        .filter(Boolean)
        .sort((a, b) => a.localeCompare(b)),
    ),
  ).map(value => ({ id: value.replace(/[^a-z0-9]+/gi, '-').toLowerCase(), label: value, value }));
}

export function getCategoryOptions(): FilterOption[] {
  return recordCategories;
}

export function suggestColabCategory(record: GetColab): string {
  const text = [record.translated, record.transcribed, record.errors].filter(Boolean).join(' ').toLowerCase();

  const match = Object.entries(categoryKeywords).find(([, keywords]) =>
    keywords.some(keyword => text.includes(keyword)),
  );
  return match?.[0] || 'Other';
}
